import { createContext, useContext } from 'react';

export interface CampaignEntryContextValue {
  loading: boolean;
  skipOnboarding: boolean;
  campaignId?: string | null;
  /** False means the account changed while the request was in flight. */
  completeEntry: (campaignId: string) => Promise<boolean>;
}

export const CampaignEntryContext = createContext<CampaignEntryContextValue>({
  loading: false,
  skipOnboarding: false,
  campaignId: null,
  completeEntry: async () => { throw new Error('campaign_entry_unavailable'); },
});
export const useCampaignEntry = () => useContext(CampaignEntryContext);
